// All imports moved to individual component files
// All CommonJS helper functions removed - no longer needed with ES6 modules
import { onSortGoTo } from 'utils';


// BuyButton - used in product pages and product cards
import 'buy-button'

// CollapsibleManager moved to components/collapsible-manager.js
import 'collapsible-manager'

// ExpandableManager moved to components/expandable-manager.js
import 'expandable-manager'

// Accessibility helper moved to utils.js

// Cart moved to components/cart.js

// MobileNavigation moved to components/mobile-navigation.js

// ModalManager moved to components/modal-manager.js
import 'modal-manager'
import 'value-picker-dialog'

// NewsletterPopup moved to components/newsletter-popup.js


// HorizontalScrollSlider moved to components/cos-slider.js
import 'cos-slider'

// CosCodeReducer moved to components/cos-code-reducer.js
import 'cos-code-reducer'

// CosTooltip moved to components/tooltip.js
import 'tooltip'

// PopoverManager moved to components/popover-manager.js
import 'popover-manager'

// ProductItemColorSwatch moved to components/product-item-color-swatch.js

// ProductItem moved to components/product-item.js
import 'product-item'

// ProgressBar moved to components/progress-bar.js
import 'progress-bar'

// Form moved to components/form.js
import 'form'

// VariantPicker moved to components/variant-picker.js
// All VariantPicker helper functions moved to components/variant-picker.js


// ProductModel moved to components/product-model.js

// ProductVideo moved to components/product-video.js

// ProductGallery moved to components/product-gallery.js

// PhotoSwipe and Drift imports moved to individual component files

// QuantityPicker moved to components/quantity-picker.js

// Form helper moved to utils.js

// ShippingEstimator moved to components/shipping-estimator.js

// ValuePicker deleted 2026-05-27 — replaced by value-picker-dialog.js
// (native <dialog class="modal modal--popover">). Imported above.

// AccountSection moved to sections/account-section.js

// All section classes moved to sections/ directory

// Tabs component
import 'tabs'

// BackToTop component
import 'back-to-top'

// CosSideCart component
import 'cart'

// Smile UI and anchor handling
(function (window, document) {
  'use strict';

  function handleSmile() {
    window.SmileUI.ready().then(() => {
      // possible param: smileUiInstance
      window.SmileUI.openPanel();
    }).catch(e => {
      // An error has occurred while initializing SmileUI
      if (window.__queueError) window.__queueError(e);
      console.warn(e);
    });
  }

  function handleTarget(targetHash) {
    // console.log('handleTarget', targetHash);
    const target = targetHash || window.location.hash;
    if (!target || target === '') return;
    // console.log('handleTarget', target);
    // window.location.hash = '';

    // smile-home
    if (target === 'smile-home' || target === '#smile-home') {
      if (window.SmileUI) {
        handleSmile();
      } else {
        document.addEventListener('smile-ui-loaded', () => {
          handleSmile();
        });
      }

      return;
    };
  
    // Resolve by id, not querySelector: a hash with Romanian diacritics (ț/ș) arrives
    // percent-encoded (#cum-i%C8%9Bi-…) and "%" is not a valid selector char → querySelector throws.
    // getElementById takes the raw id and never throws.
    let targetId = target.charAt(0) === '#' ? target.slice(1) : target;
    try { targetId = decodeURIComponent(targetId); } catch (e) { /* keep raw on malformed escape */ }
    const onSortScrollTo = document.getElementById(targetId);
    if (!onSortScrollTo) return;

    onSortGoTo(onSortScrollTo);
  
    // remove hash from url
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  addEventListener('DOMContentLoaded', () => {
    handleTarget();

    const allRelativeLinks = document.querySelectorAll('[is-anchor]');
    allRelativeLinks.forEach((link) => {
      link.addEventListener('click', (e) => { 
        // Check if the page has the same relative link
        const origin = window.location.origin;
        const href = link.getAttribute('href').replace(origin, '');
        const hrefPath = href.split('#')[0];
        
        if (hrefPath === '' || hrefPath === window.location.pathname) {
          e.preventDefault();

          const target = href.split('#')[1];
          handleTarget(target);
        }
      });
    });

    // data-goto links
    const allGoToLinks = document.querySelectorAll('[data-goto]');
    allGoToLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        let target = link.getAttribute('data-goto');
        if (target === 'nextSection') {
          const nextSection = link.closest('.shopify-section').nextElementSibling;
          if (nextSection) {
            if (nextSection.classList.contains('shopify-section')) target = nextSection.id;
          }
        }

        handleTarget(target);
      });
    });
  });

  addEventListener('hashchange', (e) => {
    handleTarget();
  });
})(window, document);
